/**
 * i18n initialization for SSP Enterprise.
 *
 * Mirrors the consumer wallet (ssp-wallet) setup: i18next + react-i18next via
 * initReactI18next, a single English resource bundle, and language detection
 * from the browser with an `en` fallback. As more languages are added, drop a
 * JSON file next to `en.json` and register it in `resources` below.
 *
 * IMPORTANT: only the English locale is edited in this repo — non-English
 * translations are handled separately (see CLAUDE.md i18n note).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

export const defaultNS = 'translation';

export const resources = {
  en: { translation: en },
} as const;

let lng = navigator.language.split('-')[0] ?? 'en';
if (!Object.keys(resources).includes(lng)) {
  lng = 'en';
}

void i18n.use(initReactI18next).init({
  resources,
  defaultNS,
  lng,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
});

export default i18n;
